// extracted by mini-css-extract-plugin
module.exports = {"header":"TagPage_header__D_IHI","title":"TagPage_title__XTogF","articles":"TagPage_articles__18nPs","p":"TagPage_p__Q1BuC"};